import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelfRemovalTriggerRow } from "@selfRemoval/models";

export interface SelfRemovalState {
  open: boolean;
  triggerRow: SelfRemovalTriggerRow | null;
}

const initialState: SelfRemovalState = {
  open: false,
  triggerRow: null,
};

const selfRemovalSlice = createSlice({
  name: "selfRemoval",
  initialState,
  reducers: {
    openSelfRemovalDialog: (state, action: PayloadAction<SelfRemovalTriggerRow>) => {
      state.open = true;
      state.triggerRow = action.payload;
    },
    closeSelfRemovalDialog: (state) => {
      state.open = false;
      state.triggerRow = null;
    },
    resetSelfRemovalState: () => initialState,
  },
});

export const { openSelfRemovalDialog, closeSelfRemovalDialog, resetSelfRemovalState } = selfRemovalSlice.actions;
export default selfRemovalSlice.reducer;
